import YTPlayer from 'yt-player';

export default {
  init($element) {

  },
  finalize($element) {
    const videoDivId = $element.find('.video').prop('id');
    const videoId = $element.find('.video').data('vid-id');
    const $splash = $element.find('.video-splash');

    const ytPlayer = new YTPlayer(`#${videoDivId}`);
    ytPlayer.load(videoId);

    $splash.on('click', function() {
      $splash.hide();
      ytPlayer.play();
    });

    ytPlayer.on('ended', () => {
      $splash.show();
    });
  },
}


// WEBPACK FOOTER //
// ./scripts/partials/flexible/fullWidthVideo.js